import graphql from "babel-plugin-relay/macro";
import { useSetAtom } from "jotai";

import { useMutationWithError } from "../../../../../../../utils/hooks/useMutationWithError";
import { isCreatingBookingAtom } from "../../../../../atoms/stores";
import {
  CreateRepeatSingleSlotBookingInput,
  useRepeatSingleSlotBookingMutation,
  useRepeatSingleSlotBookingMutation$data,
} from "./__generated__/useRepeatSingleSlotBookingMutation.graphql";
import {
  extractBookingId,
  useCreateBookingErrorHandlers,
} from "./useRepeatBookingHelpers";

export const useRepeatSingleSlotBooking = () => {
  const [repeatSingleSlotBooking, isRepeating] =
    useMutationWithError<useRepeatSingleSlotBookingMutation>(
      useRepeatSingleSlotBookingFragmentString
    );
  const setIsCreatingBooking = useSetAtom(isCreatingBookingAtom);
  const errorHandlers = useCreateBookingErrorHandlers();

  const handleCreateNewGolfBooking = (
    input: CreateRepeatSingleSlotBookingInput,
    onComplete: (bookingId: string) => void
  ) => {
    setIsCreatingBooking(true);
    repeatSingleSlotBooking({
      variables: { input },
      onCompleted: (res: useRepeatSingleSlotBookingMutation$data) => {
        setIsCreatingBooking(false);
        // useMutationWithError only calls onCompleted when success is true
        const bookingId = extractBookingId(res);
        if (bookingId) {
          onComplete(bookingId);
        }
      },
      ...errorHandlers,
    });
  };

  return [handleCreateNewGolfBooking, isRepeating] as const;
};

export const useRepeatSingleSlotBookingFragmentString = graphql`
  mutation useRepeatSingleSlotBookingMutation(
    $input: CreateRepeatSingleSlotBookingInput!
  ) {
    responsePayload: createRepeatSingleSlotBooking(input: $input) {
      errors {
        field
        code
        message
      }
      success
      startSlot {
        id
      }
      booking {
        id
      }
    }
  }
`;
